<template>
    <Teleport to="body">
        <div class="modal fade" :class="additionalClass" :data-bs-backdrop="backdrop || 'static'" :id="id" ref="root" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered adjust-margin">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="t:center p:16|8 p:32@sm">
                            <div class="f:32@xl f:24@sm f:20@<sm">
                                <slot></slot>
                            </div>
                            <div class="mt:24 flex jc:center gap:32 flex:wrap">
                                <button class="btn btn-outline-secondary color:gray03" @click="cancelHandler" data-bs-dismiss="modal" type="button" v-text="buttons?.cancel || '取消'"></button>
                                <button class="btn btn-primary" data-bs-dismiss="modal" @click="confirmHandler" type="button" v-text="buttons?.confirm || '確認'"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
    const { useThrottleFn } = VueUse;

    const root = ref();
    const emit = defineEmits(["cancel", "confirm", "hidden", "shown"]);

    let modal;

    const cancelHandler = useThrottleFn(() => {
        emit("cancel");
    });

    const confirmHandler = useThrottleFn(() => {
        emit("confirm");
    });

    const shownHandler = () => {
        emit("shown");
    };

    const hiddenHandler = () => {
        emit("hidden");
    };

    const hide = () => {
        modal.hide();
    };

    const show = () => {
        modal.show();
    };

    defineProps({
        buttons: { required: false, type: Object },
        backdrop: { required: false, type: String },
        additionalClass: { required: false, type: [Array, Object, String] },
        id: String
    });

    defineExpose({ show, hide });

    onMounted(() => {
        const el = root.value;
        modal = new bootstrap.Modal(el, { keyboard: false });

        el.addEventListener("shown.bs.modal", shownHandler);
        el.addEventListener("hidden.bs.modal", hiddenHandler);
    });
</script>
